module.exports = __webpack_public_path__ + "img/sample.6d5e521d.png";